import React from 'react';
import Icon from './Icon';

/** ArticleCard — image, category tag, title, date; external link by default. */
export default function ArticleCard({ image, category, title, date, href, to, excerpt, className = '' }) {
  const body = (
    <>
      <div className="card__media card__media--wide">
        <img src={image} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} />
      </div>
      <div className="card__body">
        {category && <span className="article-card__cat">{category}</span>}
        <h3 className="h-card article-card__title">{title}</h3>
        {excerpt && <p className="article-card__excerpt">{excerpt}</p>}
        <div className="article-card__foot">
          {date && <span className="article-card__date"><Icon name="calendar" size={13} />{date}</span>}
          <span className="link-arrow">Read<Icon name="arrow-right" size={14} /></span>
        </div>
      </div>
    </>
  );
  const cls = `card card--hover article-card${className ? ` ${className}` : ''}`;
  if (to) return <a href={to} className={cls}>{body}</a>;
  return <a href={href} className={cls} target="_blank" rel="noopener noreferrer">{body}</a>;
}
